import styled from 'styled-components'
import { Heading } from '@notino/react-styleguide'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS, SALONS_PAGE_MOBILE_BREAKPOINT } from '../../styles/constants'
import { NotinoLabelRegular400 } from '../../styles/helpers'

export const Container = styled(DefaultContainer)``

export const SalonsPageWrapper = styled.div`
	display: flex;
	gap: 32px;
`

export const SalonsPageBreadcrumbs = styled(Breadcrumb)`
	margin-bottom: 24px;

	@media (min-width: ${BREAKPOINTS.lg}) {
		margin-bottom: 24px;
	}
`

export const Grid = styled.div`
	flex: 1;
	min-width: 0; // important so the Grid does not stretch when children overflow
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-bottom: 20px;
	text-align: left !important; // override for notino global styles
`

export const CategoryDescriptionTitle = styled(Heading.H2)`
	text-align: center;
`

export const CategoryDescriptionContainer = styled.div`
	margin-top: 32px;

	@media (min-width: ${SALONS_PAGE_MOBILE_BREAKPOINT}) {
		margin-top: 64px;
	}
`

export const CategoryDescription = styled.div`
	${NotinoLabelRegular400};
	margin-bottom: 0;

	> p:not(:last-child) {
		margin-bottom: 16px;
	}
`
